var _circle, _path, _path2, _circle2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9991,
    cy: 16.9996,
    r: 15.9144,
    fill: "#FFBB0D",
    stroke: "#E89B05",
    strokeWidth: 0.951579
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8772 16.4386C31.8772 18.5489 31.4446 20.6368 30.606 22.5733C29.7675 24.5098 28.5408 26.2539 27.0018 27.6978C25.4628 29.1417 23.6441 30.2547 21.6581 30.9681C19.672 31.6816 17.5608 31.9803 15.4548 31.8458L15.5138 30.9214C17.4935 31.0478 19.478 30.767 21.3449 30.0964C23.2118 29.4257 24.9213 28.3795 26.368 27.0222C27.8147 25.665 28.9677 24.0256 29.756 22.2052C30.5442 20.3849 30.9509 18.4223 30.9509 16.4386H31.8772Z",
    fill: "#EEAD04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12281 17.5614C2.12281 15.4511 2.55544 13.3632 3.39399 11.4267C4.23254 9.49016 5.4592 7.7461 6.99821 6.30222C8.53722 4.85834 10.3559 3.74531 12.3419 3.03187C14.328 2.31842 16.4392 2.01971 18.5452 2.15418L18.4862 3.07862C16.5065 2.95221 14.522 3.233 12.6551 3.90364C10.7882 4.57428 9.07867 5.62053 7.632 6.97777C6.18533 8.33501 5.03227 9.97443 4.24404 11.7948C3.4558 13.6151 3.04912 15.5777 3.04912 17.5614H2.12281Z",
    fill: "#FFCF57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.001,
    cy: 17,
    r: 11.9298,
    fill: "#FFDD28",
    stroke: "#E89B05",
    strokeWidth: 0.842105
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2826 19.613V19.113H19.7826H18.5033V13V12.5H18.0033H16.4201H16.0904L15.9734 12.773C15.9693 12.7779 15.9637 12.7843 15.9563 12.7925C15.9243 12.8275 15.8737 12.8772 15.7997 12.9432C15.6516 13.066 15.4653 13.2019 15.2378 13.3507C15.0235 13.4878 14.806 13.607 14.5853 13.7089L14.5853 13.7089C14.3819 13.8028 14.2406 13.831 14.1504 13.831H13.6504V14.331V15.7741V16.2741H14.1504C14.3947 16.2741 14.648 16.2315 14.9069 16.156C15.1575 16.0829 15.4023 15.9891 15.6411 15.8749L15.6411 15.875L15.649 15.871C15.7424 15.8243 15.8328 15.7765 15.9201 15.7275V19.113H14.4306H13.9306V19.613V21V21.5H14.4306H19.7826H20.2826V21V19.613Z",
    fill: "#FFEF9C",
    stroke: "#E89B05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3867 15.8774C27.3867 17.3888 27.089 18.8853 26.5106 20.2816C25.9323 21.6779 25.0845 22.9467 24.0158 24.0154C22.9472 25.084 21.6784 25.9318 20.2821 26.5101C18.8858 27.0885 17.3893 27.3862 15.8779 27.3862L15.8779 26.4655C17.2684 26.4655 18.6452 26.1916 19.9298 25.6595C21.2144 25.1274 22.3816 24.3475 23.3648 23.3643C24.348 22.3811 25.1279 21.2139 25.66 19.9293C26.1921 18.6447 26.466 17.2679 26.466 15.8774H27.3867Z",
    fill: "#F3CF12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61332 18.1226C6.61332 16.6112 6.911 15.1147 7.48937 13.7184C8.06774 12.3221 8.91547 11.0533 9.98416 9.98464C11.0528 8.91596 12.3216 8.06823 13.7179 7.48986C15.1142 6.91149 16.6107 6.6138 18.1221 6.6138L18.1221 7.53451C16.7316 7.53451 15.3548 7.80837 14.0702 8.34047C12.7856 8.87257 11.6184 9.65249 10.6352 10.6357C9.652 11.6189 8.87209 12.7861 8.33999 14.0707C7.80789 15.3553 7.53402 16.7321 7.53402 18.1226H6.61332Z",
    fill: "#FFEF9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPosition);
export default __webpack_public_path__ + "static/media/first_position.49f5b31f8cf8c43f8b3e896f7898f05f.svg";
export { ForwardRef as ReactComponent };